/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { BadgesDaoService } from '../badges-dao.service';

// CONSTANTS
const BADGES_KEY = 'badges';

@Injectable()
export class BadgesStorageDaoService implements BadgesDaoService {
  // Private Member

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private keyValueStorage: KeyValuePersistenceService
  ) {}

  public async saveBadges(badges: any): Promise<void> {
    await this.keyValueStorage.store(BADGES_KEY, badges);
  }
  public async getBadges(): Promise<any> {
    return await this.keyValueStorage.load(BADGES_KEY);
  }

  public async reset() {
    await this.keyValueStorage.delete(BADGES_KEY);
  }

  public async clear() {
    await this.keyValueStorage.delete(BADGES_KEY);
  }

  // Private Functions
}
